'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _drgs = require('./drgs.html');

var _drgs2 = _interopRequireDefault(_drgs);

var _drgs3 = require('./drgs.controller');

var _drgs4 = _interopRequireDefault(_drgs3);

require('./drgs.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var drgsComponent = {
  restrict: 'E',
  bindings: {},
  template: _drgs2.default,
  controller: _drgs4.default,
  controllerAs: 'vm'
};

exports.default = drgsComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/drgs/drgs.component.js